module.exports = __webpack_public_path__ + "img/abcs_nsfw.4491915c.svg";